module.exports = __webpack_public_path__ + "static/media/icon-notes.ec1b95a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-notes.svg
// module id = 956
// module chunks = 0